import ExcludeFromLookup from '../../../../../../enums/ExcludeFromLookup';
import stripCharacters from '../../../../../utils/strip-characters';
import {onlyBillingAddresses, onlyDeliveryAddresses} from '../../addressFormType';
import enabledSetting from '../../enabledSetting';
import {sixDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';
import * as chineseCharsWhenTaxable from '../../validationByCountry/China/chinese-characters-validators';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import county from '../../defaultFieldDefinitions/County';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';
import maxLatinWhenTaxable from '../../validationByCountry/China/maxLatinWhenTaxable';

const hideCompanyName = !!enabledSetting('hide_company_name');

const FieldDefinitionCN = [
  {
    name: 'addressee',
    label: 'checkout.delivery.address.field.label.name.text',
    filterCondition: onlyDeliveryAddresses,
    required: true,
    maxLength: 35,
    validate: [required.fullName, max.lengthAddressee(35), chineseCharsWhenTaxable.fullName],
    excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.fullName],
  },
  {
    name: 'companyName',
    label: 'checkout.delivery.address.field.label.company.name.text',
    hideCondition: hideCompanyName,
    maxLength: 35,
    validate: [max.lengthCompany(35), chineseCharsWhenTaxable.basic],
    mobileStepIgnoreValidation: [chineseCharsWhenTaxable.basic],
  },
  {
    ...county, // province
    required: true,
    filterCondition: onlyDeliveryAddresses,
    validate: [required.county, max.lengthAddress(35), maxLatinWhenTaxable('county', 5)],
    mobileStepIgnoreValidation: [maxLatinWhenTaxable('county', 5)],
  },
  {
    ...townCity, // townCity
    filterCondition: onlyDeliveryAddresses,
    validate: [required.townCity, max.lengthAddress(35), maxLatinWhenTaxable('town', 5)],
    mobileStepIgnoreValidation: [maxLatinWhenTaxable('town', 5)],
  },
  {
    ...streetName, // district
    label: 'checkout.delivery.address.field.label.district.text',
    filterCondition: onlyDeliveryAddresses,
    validate: [required.address1, max.lengthAddress(35), maxLatinWhenTaxable('address1', 5)],
    mobileStepIgnoreValidation: [maxLatinWhenTaxable('address1', 5)],
  },
  {
    ...addressLine2, // house name/number, streetname and additional information
    label: 'checkout.delivery.address.field.label.houseNameNumber.with.streetName.text',
    required: true,
    validate: [required.address2, max.lengthAddress(35), maxLatinWhenTaxable('address2', 5)],
    filterCondition: onlyDeliveryAddresses,
    mobileStepIgnoreValidation: [maxLatinWhenTaxable('address2', 5)],
  },
  {
    ...postCode,
    fixedLength: 6,
    validate: [required.postCode, max.lengthPostCode(6), sixDigitsPostcodeValidator],
    filterCondition: onlyDeliveryAddresses,
    validationCleaner: stripCharacters(' '),
  },
  {
    ...county,
    filterCondition: onlyBillingAddresses,
  },
  {
    ...townCity,
    filterCondition: onlyBillingAddresses,
  },
  {
    ...streetName,
    label: 'checkout.delivery.address.field.label.district.text',
    filterCondition: onlyBillingAddresses,
  },
  {
    ...addressLine2,
    label: 'checkout.delivery.address.field.label.houseNameNumber.with.streetName.text',
    required: true,
    filterCondition: onlyBillingAddresses,
  },
  {
    ...postCode,
    fixedLength: 6,
    validate: [required.postCode, max.lengthPostCode(6), sixDigitsPostcodeValidator],
    validationCleaner: stripCharacters(' '),
    filterCondition: onlyBillingAddresses,
  },
];

export default FieldDefinitionCN;
